import { render, staticRenderFns } from "./DetailCaddy.vue?vue&type=template&id=7ced2138"
import script from "./DetailCaddy.js?vue&type=script&lang=js&external"
export * from "./DetailCaddy.js?vue&type=script&lang=js&external"
import style0 from "./DetailCaddy.vue?vue&type=style&index=0&id=7ced2138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports